export default __webpack_public_path__ + "static/media/monImage.14cde585.jpg";